module.exports = __webpack_public_path__ + "img/Bismillah.10da43de.png";